import { $cookies } from "../plugins/cookie";
import { $api } from "../services/api";
import { $config } from "../conf";

const state = {
  isFan: false,
  globalUserId: "",
  session: "",
  openId: "",
  unionId: "",
  token: "",
  tokenInfo: {},
  info: {},
  tenantId:'',
  instanceId:'',
  moduleId:'',

};
const getters = {};
const actions = {
  init({ commit, dispatch }) {
    dispatch("loadGlobalUserId");
    let smarketMember = $cookies.smarketMember($config.schemaId);
    if (smarketMember) {
      commit("updateSession", smarketMember.session);
      commit("updateInfo", {
        memberId: smarketMember.memberId,
      });
    }
  },

  async loadGlobalUserId({ state, commit }) {
    let globalUserId = $cookies.globalUserId();
    if (!globalUserId) {
      const globalUserIdData = await $api.onAnonymousGetId();
      globalUserId = globalUserIdData.content;
      $cookies.globalUserId(globalUserId);
    }
    commit("updateGlobalUserId", globalUserId);
    return state.globalUserId;
  },

};
const mutations = {
  updateGlobalUserId(state, globalUserId) {
    state.globalUserId = globalUserId;
  },
  updateTenantId(state, tenantId) {
    state.tenantId = tenantId;
  },
  updateModuleId(state, moduleId) {
    state.moduleId = moduleId;
  },
  updateInstanceId(state, instanceId) {
    state.instanceId = instanceId;
  },
  updateToken(state, token) {
    state.token = token;
  },
  updateOpenId(state, openId) {
    state.openId = openId;
  },
  updateUnionId(state, unionId) {
    state.unionId = unionId;
  },
  updateSession(state, session) {
    state.session = session;
  },
  updateIsFan(state, isFan) {
    state.isFan = isFan;
  },
  updateInfo(state, info) {
    state.info = info;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
